import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../../../../config/config.js";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Acumulados from "../components/Acumulado/Acumulado";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const FullScreenModalConfigAcumulado = ({ open, setOpen }) => {
  const { idevent, idsport } = useParams();
  const [acumulados, setAcumulados] = useState([]);
  const [showPhaseModal, setShowPhaseModal] = useState(false);

  const getAcumulados = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/getacumulados`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      setAcumulados(response.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (idevent && idsport) {
      getAcumulados();
    }
  }, [idevent, idsport]);

  const handleActualizarAcumulados = async () => {
    try {
      const response = await axios.patch(`${API_BASE_URL}/patchacumulados`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      toast.success("¡Se actualizó los acumulados!");
      console.log("Response", response);
    } catch (error) {
      toast.error("¡Hubo un error al actualizar los Acumulados!");
      console.error("Error al actualizar las Posiciones", error);
    }
  };

  const handleActualizarAcumuladosClasificacion = async () => {
    console.log("Actualizar acumulados de clasificación");
  };

  const handleConfirmarClasificados = () => {
    setShowPhaseModal(true);
  };

  const generarOctavos = async () => {
    try {
      const clasificados = acumulados
        .filter((acum) => acum.isClasificado)
        .sort((a, b) => a.posicion - b.posicion);

      const matches = [];
      const totalClasificados = clasificados.length;

      for (let i = 0; i < 8; i++) {
        // Solo 8 matches para octavos
        const participant1 = clasificados[i];
        const participant2 = clasificados[totalClasificados - 1 - i];

        const match = {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 2, // Octavos de final
          idparticipant1: participant1.idparticipant,
          idparticipant2: participant2.idparticipant,
          state: 1,
          nro_fecha: 1,
          codigo_match: `oct${i + 1}`,
          tag_final: `${participant1.posicion}° lugar vs ${participant2.posicion}° lugar`,
        };
        matches.push(match);
      }

      console.log("info matches", matches);
      await axios.post(`${API_BASE_URL}/postmatches`, matches);
      toast.success("¡Octavos de final generados exitosamente!");
      setShowPhaseModal(false);
    } catch (error) {
      toast.error("Error al generar los octavos de final.");
      console.error("Error al generar los octavos:", error);
    }
  };

  const generarCuartos = async () => {
    try {
      // Obtener los partidos de octavos
      const response = await axios.post(`${API_BASE_URL}/getmatches`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 2, // Fase final
        nro_fecha: 1, // Octavos
      });

      const octavos = response.data;

      // Verificar que hay 8 partidos de octavos para generar cuartos
      if (octavos.length !== 8) {
        toast.error(
          "Debe haber exactamente 8 partidos de octavos para generar los cuartos de final."
        );
        return;
      }

      const matches = [];

      // Generar los cuartos de final
      const cuartosMapping = [
        [0, 7], // cua1: oct1 vs oct8
        [1, 6], // cua2: oct2 vs oct7
        [2, 5], // cua3: oct3 vs oct6
        [3, 4], // cua4: oct4 vs oct5
      ];

      cuartosMapping.forEach(([i1, i2], index) => {
        const match1 = octavos[i1];
        const match2 = octavos[i2];

        const newMatch = {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 2, // Fase final
          nro_fecha: 2, // Cuartos
          idmatch_pre1: match1.idmatch,
          idmatch_pre2: match2.idmatch,
          state: 1,
          codigo_match: `cua${index + 1}`,
          tag_final: `Ganador ${i1 + 1} vs Ganador ${i2 + 1}`,
        };

        matches.push(newMatch);
      });

      // Enviar los partidos de cuartos al backend
      console.log("a ver los cuartos", matches);
      await axios.post(`${API_BASE_URL}/postmatches`, matches);
      toast.success("¡Cuartos de final generados exitosamente!");
      setShowPhaseModal(false);
    } catch (error) {
      toast.error("Error al generar los cuartos de final.");
      console.error("Error al generar los cuartos:", error);
    }
  };

  const generarSemifinal = async () => {
    try {
      // Obtener los partidos de cuartos
      const response = await axios.post(`${API_BASE_URL}/getmatches`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 2, // Fase final
        nro_fecha: 2, // Cuartos
      });

      const cuartos = response.data;

      // Verificar que hay 4 partidos de cuartos para generar semifinales
      if (cuartos.length !== 4) {
        toast.error(
          "Debe haber exactamente 4 partidos de cuartos para generar las semifinales."
        );
        return;
      }

      const matches = [];

      // Generar las semifinales
      const semifinalMapping = [
        [0, 3], // sem1: cua1 vs cua4
        [1, 2], // sem2: cua2 vs cua3
      ];

      semifinalMapping.forEach(([i1, i2], index) => {
        const match1 = cuartos[i1];
        const match2 = cuartos[i2];

        const newMatch = {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 2, // Fase final
          nro_fecha: 3, // Semifinal
          idmatch_pre1: match1.idmatch,
          idmatch_pre2: match2.idmatch,
          state: 1,
          codigo_match: `sem${index + 1}`,
          tag_final: `Semifinalista ${i1 + 1} vs Semifinalista ${i2 + 1}`,
        };

        matches.push(newMatch);
      });

      // Enviar los partidos de semifinales al backend
      console.log("a ver las semifinales", matches);
      await axios.post(`${API_BASE_URL}/postmatches`, matches);
      toast.success("¡Semifinales generadas exitosamente!");
      setShowPhaseModal(false);
    } catch (error) {
      toast.error("Error al generar las semifinales.");
      console.error("Error al generar las semifinales:", error);
    }
  };

  const generarFinal = async () => {
    try {
      // Obtener los partidos de semifinales
      const response = await axios.post(`${API_BASE_URL}/getmatches`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 2, // Fase final
        nro_fecha: 3, // Semifinales
      });

      const semifinales = response.data;

      if (semifinales.length !== 2) {
        toast.error(
          "Debe haber exactamente 2 partidos de semifinales para generar la final."
        );
        return;
      }

      const matches = [];

      // Partido por el tercer lugar (perdfin1)
      const match3rdPlace = {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 2, // Final
        nro_fecha: 4, // Final
        idmatch_pre1: semifinales[0].idmatch, // Semifinal 1
        idmatch_pre2: semifinales[1].idmatch, // Semifinal 2
        state: 1,
        track_match_final: 0, // Indica que es un partido por el tercer lugar
        codigo_match: "perdfin1",
        tag_final: "Por el 3er lugar",
      };

      matches.push(match3rdPlace);

      // Partido por el primer lugar (fin1)
      const matchFinal = {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 2, // Final
        nro_fecha: 4, // Final
        idmatch_pre1: semifinales[0].idmatch, // Semifinal 1
        idmatch_pre2: semifinales[1].idmatch, // Semifinal 2
        state: 1,
        codigo_match: "fin1",
        tag_final: "Por el 1er lugar",
      };

      matches.push(matchFinal);

      // Enviar los partidos de la final al backend
      console.log("a ver la final", matches);
        await axios.post(`${API_BASE_URL}/postmatches`, matches);
      toast.success("¡Final generada exitosamente!");
      setShowPhaseModal(false);
    } catch (error) {
      toast.error("Error al generar la final.");
      console.error("Error al generar la final:", error);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <ModalDialog layout="fullscreen">
          <ModalClose sx={{ width: "35px" }} />
          <DialogTitle className="text-2xl font-bold text-gray-800">
            Configuración para Fase Final por Acumulado
          </DialogTitle>
          <DialogContent>
            <div className="mb-4 flex justify-evenly space-x-4">
              <button
                className="bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={handleActualizarAcumulados}
              >
                1. Posiciones a Acumulados
              </button>
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={handleActualizarAcumuladosClasificacion}
              >
                2. Actualización Final de Acumulados para Clasificación
              </button>
              <button
                className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={handleConfirmarClasificados}
              >
                3. Confirmar y Enviar Clasificados
              </button>
            </div>
            <Acumulados
              acumulados={acumulados}
              setAcumulados={setAcumulados}
              getAcumulados={getAcumulados}
            />
          </DialogContent>
        </ModalDialog>
      </Modal>

      <Modal open={showPhaseModal} onClose={() => setShowPhaseModal(false)}>
        <ModalDialog>
          <DialogTitle className="text-xl font-bold text-gray-800">
            Generar Fases
          </DialogTitle>
          <DialogContent>
            <div className="mb-4 flex flex-col space-y-4">
              <button
                className="bg-green-400 hover:bg-green-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={generarOctavos}
              >
                Generar Octavos
              </button>
              <button
                className="bg-blue-400 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={generarCuartos}
              >
                Generar Cuartos
              </button>
              <button
                className="bg-yellow-400 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={generarSemifinal}
              >
                Generar Semifinal
              </button>
              <button
                className="bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                onClick={generarFinal}
              >
                Generar Final
              </button>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default FullScreenModalConfigAcumulado;
